import { useSelector } from 'react-redux';
import * as AIReportService from 'services/ai/report';

export const useAIReportService = () => {
  const { token, tenant_id } = useSelector((store) => store.user_data);

  const fetchPulseLine = async (options = {}) => {
    const { payload } = await AIReportService.fetchPulseLine({ ...options, token });
    return payload;
  };

  const fetchActionSuggestions = async () => {
    const { payload } = await AIReportService.fetchSuggestions({
      token,
      query_string: `tenant_id=${tenant_id}`
    });

    if (!payload) return [];
    const { suggestions } = payload;
    if (Array.isArray(suggestions)) return suggestions;
    return [];
  };

  const fetchChartExplain = async (context) => {
    const { payload } = await AIReportService.fetchChartExplain({
      token,
      data: { type: 'chart-explain', context }
    });
    if (!payload?.summary) return null;
    return payload.summary;
  };

  return { fetchPulseLine, fetchActionSuggestions, fetchChartExplain };
};
